import { render, staticRenderFns } from "./makeSpecialCategory.vue?vue&type=template&id=8435a364"
import script from "./makeSpecialCategory.vue?vue&type=script&lang=js"
export * from "./makeSpecialCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports